import React from "react";
import {
  AppBar,
  Box,
  Button,
  IconButton,
  Typography,
  useMediaQuery,
  Container,
} from "@mui/material";
import facebookIcon from "../assets/landing/facebook-icon.svg";
import { useTheme } from "@mui/material/styles";

const Navbar = () => {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md")); // Checks if the screen size is "md" or smaller

  return (
    <AppBar
      position="static"
      sx={{ backgroundColor: "rgba(49, 180, 75, 1)", boxShadow: "none" }}
    >
      <Container
        maxWidth={false}
        sx={{
          justifyContent: "space-between",
          minHeight: "auto", // 🔑 Removes default minHeight
          paddingY: 0, // 🔑 Removes vertical padding
        }}
        disableGutters // 🔑 Optional: removes extra padding on left/right edges if needed
      >
        <Box
          width={{ xl: "70%", lg: "90%", md: "85%", sm: "90%", xs: "95%" }}
          marginX="auto"
          display="flex"
          flexDirection="row"
          justifyContent="space-between"
        >
          {/* This section will be hidden on mobile and tablet */}
          {!isMobileOrTablet && (
            <Box sx={{ display: "flex" }}>
              <Box sx={{ borderLeft: "1px solid white" }}>
                <Button
                  color="inherit"
                  sx={{ textTransform: "none", whiteSpace: "nowrap" }}
                >
                  How To Order
                </Button>
              </Box>
              <Box
                sx={{
                  borderLeft: "1px solid white",
                  borderRight: "1px solid white",
                }}
              >
                <Button
                  color="inherit"
                  sx={{ textTransform: "none", whiteSpace: "nowrap" }}
                >
                  Shipping And Returns
                </Button>
              </Box>
            </Box>
          )}

          {/* This section will also be hidden on mobile and tablet */}
          {!isMobileOrTablet && (
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <Box sx={{ borderRight: "1px solid white" }}>
                <IconButton color="inherit">
                  <img
                    src={facebookIcon}
                    alt="Facebook"
                    style={{ width: 24, height: 24 }}
                  />
                </IconButton>
              </Box>
              <Box sx={{ borderRight: "1px solid white" }}>
                <Button
                  color="inherit"
                  sx={{ textTransform: "none", whiteSpace: "nowrap" }}
                >
                  FAQs
                </Button>
              </Box>
              <Box sx={{ borderRight: "1px solid white" }}>
                <Button
                  color="inherit"
                  sx={{ textTransform: "none", whiteSpace: "nowrap" }}
                >
                  Contact Us
                </Button>
              </Box>
            </Box>
          )}

          {/* This section will only be visible on mobile and tablet */}
          {isMobileOrTablet && (
            <Box
              display="flex"
              justifyContent="center"
              alignItems="center"
              width="100%"
              sx={{ textAlign: "center" }}
            >
              <Typography
                variant="contained"
                sx={{
                  color: "#fff",
                  textTransform: "none",
                  whiteSpace: "nowrap",
                  fontSize: "1.2rem",
                }}
              >
                Shop for Plumeria In Stock Today
              </Typography>
            </Box>
          )}
        </Box>
      </Container>
    </AppBar>
  );
};

export default Navbar;
